let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("8q5eZ")).then(() => parcelRequire('eVi3w'));